import React from 'react';
import { usePagination, DOTS } from './usePagination';
const Pagination = props => {
	const {
		onPageChange,
		totalCount,
		siblingCount = 1,
		currentPage,
		pageSize
	} = props;

	const paginationRange = usePagination({
		currentPage,
		totalCount,
		siblingCount,
		pageSize
	});

	if (currentPage === 0 || paginationRange.length < 2) {
		return null;
	}

	const onNext = () => {
		onPageChange(currentPage + 1);
	};

	const onPrevious = () => {
		onPageChange(currentPage - 1);
	};

	let lastPage = paginationRange[paginationRange.length - 1];
	const startEntry = (currentPage - 1) * pageSize + 1;
	// Calculate the ending entry index
	const endEntry = Math.min(currentPage * pageSize, totalCount);
	return (
		<div className='pagination-sec'>
			<span className='pagination-total-count'>Showing {startEntry} to {endEntry} of {totalCount} entries</span>
			<ul
				className='pagination-container'
			>
				<li
					className={`pagination-item ${currentPage === 1 ? 'disabled' : ""}`}
					onClick={onPrevious}
				>
					<i className="fa-solid fa-chevron-left"></i>
				</li>
				{paginationRange.map((pageNumber,i) => {
					if (pageNumber === DOTS) {
						return <li key={`pagination-key-${pageNumber}-dots-${i}`} className={`pagination-item dots'`}>&#8230;</li>;
					}
					return (
						<li key={`pagination-key-${pageNumber}-${i}`}
							className={`pagination-item ${pageNumber === currentPage ? 'selected' : ""}`}
							onClick={() => onPageChange(pageNumber)}
						>
							{pageNumber}
						</li>
					);
				})}
				<li
					className={`pagination-item ${currentPage === lastPage ? 'disabled' : ""}`}
					onClick={onNext}
				>
					<i className="fa-solid fa-chevron-right"></i>
				</li>
			</ul>
		</div>
	);
};

export default Pagination;